import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import stl from "./MarketingBanner.module.css";
import PictureResponsiveImage from "@componentsShared/PictureResponsiveImage";
import { thumbUrl } from "@/utils/imagesHelpers";
import useIsMobile from "@hooks/useIsMobile";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import Container from "@/components/sharedComponents/container/Container";
var MarketingBanner = function MarketingBanner(_ref) {
  var src = _ref.src,
    width = _ref.width,
    height = _ref.height,
    marketingBanner = _ref.marketingBanner,
    loading = _ref.loading;
  var isMobile = useIsMobile();
  var stlObj = _objectSpread({}, height ? {
    height: height + "px"
  } : {});
  var images = {
    sources: [{
      media: "(min-width: 768px)",
      image: thumbUrl(marketingBanner === null || marketingBanner === void 0 ? void 0 : marketingBanner.desktop, "hero-v1", isMobile ? "0x154" : "0x960", true)
    }, {
      media: "(max-width: 767px)",
      image: thumbUrl(marketingBanner === null || marketingBanner === void 0 ? void 0 : marketingBanner.mobile, "hero-v1", isMobile ? "0x154" : "0x960", true)
    }],
    defaultImage: thumbUrl(marketingBanner === null || marketingBanner === void 0 ? void 0 : marketingBanner.desktop, "hero-v1", isMobile ? "0x154" : "0x960", true),
    alt: "M"
  };
  return /*#__PURE__*/React.createElement(Container, {
    className: stl.wrapper
    // style={stlObj}
  }, loading ? /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: "100%",
    divWidth: "100%"
  }) : marketingBanner ? /*#__PURE__*/React.createElement(PictureResponsiveImage, {
    sources: images.sources,
    defaultImage: images.defaultImage,
    alt: images.alt
  }) : null);
};
export default MarketingBanner;